import { FETCH_SUCCESS, TABLE_UPDATE } from "../types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { IGPTable } from "ui/Table/Table";
import { AnyAction } from "redux";

function ProvidersTableReducer(
    state: IGPTable = {
        id: "ProvidersTable",
        columns: [
            {
                field: "name",
                headName: "Provider",
                sortable: true,
            },
            {
                field: "uuid",
                headName: "UUID",
                sortable: false,
            },
            {
                field: "actions",
            },
        ],
        pagination: {
            isLastPage: true,
            page: 1,
            per_page: 20,
            total: 0,
        },
        search: "",
        sort: { provider: "asc" },
    },
    action: AnyAction,
) {
    switch (action.type) {
        case FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;

        case TABLE_UPDATE:
            return tableUpdate(state, action);

        default:
            return state;
    }
}

export default ProvidersTableReducer;
